<script setup>
const emit = defineEmits(['next'])
defineProps({
  errorMessage: {
    type: String,
    default: '',
  },
})

const form = defineModel({ type: Object, required: true })

const localErrorMessage = ref('')

function nextStep() {
  if (form.value.password1 !== form.value.password2) {
    localErrorMessage.value = 'Wachtwoorden komen niet overeen'
  } else {
    emit('next')
  }
}
</script>

<template>
  <RegisterStep title="Algemene gegevens" :step="1" @next="nextStep">
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
      <RegisterInputLabel title="Voornaam contactpersoon">
        <Input v-model="form.firstName" auto-focus required />
      </RegisterInputLabel>

      <RegisterInputLabel title="Achternaam contactpersoon">
        <Input v-model="form.lastName" required />
      </RegisterInputLabel>

      <RegisterInputLabel title="Bedrijfsnaam">
        <Input v-model="form.companyName" required />
      </RegisterInputLabel>

      <RegisterInputLabel title="Email">
        <Input v-model="form.email" type="email" required />
      </RegisterInputLabel>

      <RegisterInputLabel title="Wachtwoord">
        <Input v-model="form.password1" type="password" required />
      </RegisterInputLabel>

      <RegisterInputLabel title="Bevestig wachtwoord">
        <Input v-model="form.password2" type="password" required />
      </RegisterInputLabel>
    </div>
  </RegisterStep>
</template>
